import { useState, useEffect } from 'react';
import guidesApi, { Guide } from '../api/developerHub/guidesApi';

interface UseGuidesReturn {
  guides: Guide[];
  loading: boolean;
  error: string | null;
}

let cachedGuides: Guide[] | null = null;

const useGuides = (): UseGuidesReturn => {
  const [guides, setGuides] = useState<Guide[]>(cachedGuides || []);
  const [loading, setLoading] = useState(!cachedGuides);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (cachedGuides) return;

    guidesApi.getGuides()
      .then((guidesData) => {
        cachedGuides = guidesData;
        setGuides(guidesData);
        setLoading(false);
        return guidesData;
      })
      .catch((error_: Error) => {
        setError(error_.message);
        setLoading(false);
      });
  }, []);

  if (error) throw new Error(error);
  return { guides, loading, error };
};

export default useGuides;
